<script>
import ItemList from 'Vue/Web/ItemList.vue';
import ClinicSearchSelect from 'Vue/Web/Common/Clinic/ClinicSearchSelect.vue';

export default {
    name: 'ListController',
    components: {
        ItemList,
        ClinicSearchSelect,
    },
    props: {},
    mounted() {
    },
    data() {
        return {
        };
    },
    methods: {

    },
};
</script>
<style scoped lang="scss">

</style>
